// extracted by mini-css-extract-plugin
module.exports = {"check_box":"CheckBox_check_box__2j8EC","checkbox_root":"CheckBox_checkbox_root__1dgy_"};